import { NavigationActions, SystemActions } from '@ignitesales/neuro-application';

const productsReducer = (state, action) => {
  switch (action.type) {
    case SystemActions.APP_READY:
    case NavigationActions.PAGE_REQUEST_COMPLETED: {
      if(state.products && state.products.groups){
        state.products.groups = (state.products.groups || []).filter(g => g.name !== "addOns")
      }
      return state;
    }

    default:
      return state;
  }
};

export default productsReducer;
